module.exports = __webpack_public_path__ + "static/media/etenders_logo_w.d6788569.svg";